import React from 'react';

import {
  ButtonText,
  Container,
  ReloadButton,
  ReloadIcon,
  ReloadText
} from './styles';

interface ReloadProps {
  onPress(): void;
  loaded: boolean;
  message?: string;
}

const Reload: React.FC<ReloadProps> = ({
  children,
  onPress,
  loaded,
  message = 'Não foi possível carregar as informações',
  ...rest
}) => {
  return (
    <>
      {loaded && children}
      {!loaded && (
        <Container {...rest}>
          <ReloadText>{message}</ReloadText>
          <ReloadButton
            testID="reloadButton"
            activeOpacity={0.7}
            onPress={onPress}
          >
            <ReloadIcon name="md-refresh" size={24} />
            <ButtonText>Recarregar informações</ButtonText>
          </ReloadButton>
        </Container>
      )}
    </>
  );
};

export default Reload;
